import React, { useState, useEffect } from "react";
import HSTable from "../../components/global/Table";
import { getAllDeaerators } from '../../services/dearators/DeaeratorService';
import IconButton from '@mui/material/IconButton';
import { Search } from "@mui/icons-material";
import DeaeratorDetail from '../../components/dearators_phc/DeaeratorDetail';
import Deaerotor from "../../assets/deaerotor_card.png";

const Deaerators = () => {

    const columns = [
        { field: "name", label: "Nome", sortable: true },
        { field: "fileName", label: "Ficheiro", sortable: true },
        { field: "fileType", label: "Importado De", paddingLeft: 5, sortable: true },
        {
            field: "actions",
            label: "Ver Detalhes",
            align: "left",
            paddingLeft: 5,
            render: (_, row) => (
                <IconButton onClick={() => handleViewDetails(row)}>
                    <Search fontSize="medium" sx={{ color: "primary.main" }} />
                </IconButton>
            ),
        },
    ];

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalElements, setTotalElements] = useState(0);
    const [selectedId, setSelectedId] = useState('');
    const [deaerator, setDeaeratorInDetail] = useState({});
    const [searchString, setSearchString] = useState('');

    useEffect(() => {
        (async () => {
            await getAllDeaerators(page, rowsPerPage, searchString).then(res => {
                setTotalElements(res['totalElements']);
                setData(res['content']);
                setLoading(false);
            });
        })();
    }, [page, rowsPerPage, searchString]);

    const handleViewDetails = (deaerator) => {
        setSelectedId(deaerator['id']);
        let obj = deaerator;
        obj['image'] = Deaerotor;
        setDeaeratorInDetail(obj);
    }

    const onSearchChange = (search) => {
        setSearchString(search);
    }


    return (
        <>
            <div style={{ boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)' }}>
                <HSTable
                    columns={columns}
                    data={data}
                    loading={loading}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    enableSearch={true}
                    totalCount={totalElements}
                    onRowsPerPageChange={(newRowsPerPage) => { setRowsPerPage(newRowsPerPage); setPage(0); }}
                    onPageChange={(page) => setPage(page)}
                    onSearchChange={onSearchChange}
                />
            </div>
            {selectedId !== '' &&
                <DeaeratorDetail
                    deaerator={deaerator}
                    onClose={() => setSelectedId('')}
                />
            }
        </>
    );
}

export default Deaerators;